export default function CsvImportPanel({
  title,
  file,
  fileInputRef,
  isImportActive,
  importStatus,
  isImportPreparing,
  showDeterminateImportProgress,
  importProgressPercent,
  importStatusLabel,
  totalImportRows,
  onFileChange,
  onUpload,
}) {
  const secondaryButtonStyle = {
    padding: "10px 16px",
    borderRadius: "12px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap"
  };

  const primaryButtonStyle = {
    padding: "10px 16px",
    borderRadius: "12px",
    border: "none",
    background: "#0f766e",
    color: "#ffffff",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap"
  };

  return (
    <>
      <h2 style={{ margin: "0 0 18px", fontSize: "24px", color: "#0f172a" }}>{title}</h2>
      <div
        style={{
          display: "grid",
          gap: "16px",
          padding: "18px",
          borderRadius: "18px",
          border: "1px solid #dbe4f0",
          background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)"
        }}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          disabled={isImportActive}
          onChange={(e) => onFileChange(e.target.files[0] || null)}
          style={{ display: "none" }}
        />
        <div style={{ display: "grid", gap: "10px" }}>
          <div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.08em", color: "#64748b", fontWeight: 700 }}>
            CSV file
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={() => {
                if (!isImportActive) {
                  fileInputRef.current?.click();
                }
              }}
              disabled={isImportActive}
              style={{
                ...secondaryButtonStyle,
                opacity: isImportActive ? 0.6 : 1,
                cursor: isImportActive ? "not-allowed" : "pointer"
              }}
            >
              Choose file
            </button>
            <div
              title={file?.name || "No file selected"}
              style={{
                flex: "1 1 280px",
                minWidth: 0,
                padding: "10px 14px",
                borderRadius: "12px",
                border: "1px solid #dbe4f0",
                background: file ? "#ffffff" : "#f8fafc",
                color: file ? "#0f172a" : "#64748b",
                fontSize: "14px",
                fontWeight: file ? 600 : 500,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {file?.name || "No file selected"}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={onUpload}
            disabled={isImportActive || !file}
            style={{
              ...primaryButtonStyle,
              opacity: isImportActive || !file ? 0.6 : 1,
              cursor: isImportActive || !file ? "not-allowed" : "pointer"
            }}
          >
            {isImportActive ? "Importing..." : "Upload CSV"}
          </button>
        </div>
      </div>
      {importStatusLabel && (
        <div style={{ marginTop: "14px", marginBottom: "18px", maxWidth: "420px" }}>
          <div
            style={{
              height: "12px",
              background: "#e0e0e0",
              borderRadius: "999px",
              overflow: "hidden"
            }}
          >
            <div
              style={{
                width: showDeterminateImportProgress ? `${importProgressPercent}%` : "40%",
                height: "100%",
                background: importStatus?.stage === "failed"
                  ? "#c62828"
                  : isImportPreparing
                    ? "linear-gradient(90deg, #81c784 0%, #2e7d32 100%)"
                    : "#2e7d32",
                opacity: isImportPreparing ? 0.75 : 1,
                transition: "width 0.2s ease"
              }}
            />
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              color: importStatus?.stage === "failed" ? "#c62828" : "#333"
            }}
          >
            {importStatusLabel}
          </div>
          {importStatus?.stage === "processing" && totalImportRows > 0 && (
            <div style={{ marginTop: "8px", fontSize: "12px", color: "#666" }}>
              {importStatus.importedRows || 0} cards imported so far
            </div>
          )}
        </div>
      )}
    </>
  );
}